export enum UserRole {
  system = -1,
  guest = 0,
  streamer = 1,
  assistant = 2,
  member = 3,
  superAdmin = 4,
  chatbot = 100,
}

export enum UserStatus {
  unknown = 0,
  active = 1,
  inactive = 2,
  banned = 3,
}

export const WalletType = {
  GoldCoin: 1,
} as const;
